<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="500px"
  >
    <div>
      <v-card
        :class="backgroundClass"
        height="350px">
        <v-card-title>
          <v-row justify="end">
            <v-btn
              icon
              @click.stop="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>

        <v-card-actions class="card-actions">
          <v-layout justify="end">
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              @click="imageClickEvent"
            >
              詳細はこちら　▶︎
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>

import {mapState} from 'vuex'

export default {
  name: 'EcContractSinglePlanGuideDialog',
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    fromUser: {
      type: Boolean,
      default: () => false,
    },
    fromEmission: {
      type: Boolean,
      default: () => false,
    },
    fromTransportRoute: {
      type: Boolean,
      default: () => false,
    },
    fromDisposer: {
      type: Boolean,
      default: () => false,
    }
  },
  data () {
    return {
    }
  },
  computed: {
    backgroundClass() {
      if (this.fromUser) {
        return 'bg_user'
      }
      if (this.fromEmission) {
        return 'bg_haishutu'
      }
      if (this.fromTransportRoute) {
        return 'bg_transport_route'
      }
      if (this.fromDisposer) {
        return 'bg_disposer'
      }
      return 'bg_user'
    }
  },
  methods: {
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    imageClickEvent () {
      window.open(process.env.VUE_APP_TRIAL_GRADEUP_GUIDE_URL, "_blank" )
    },
  }
}

</script>

<style scoped lang="scss">
  .bg_user {
    background-image: url("@/assets/images/upgrade_guides/bnr_user_500x350.png");
  }
  .bg_haishutu {
    background-image: url("@/assets/images/upgrade_guides/bnr_haishutu_500x350.png");
  }
  .bg_transport_route {
    background-image: url("@/assets/images/upgrade_guides/bnr_route_500x350.png");
  }
  .bg_disposer {
    background-image: url("@/assets/images/upgrade_guides/bnr_shobun_500x350.png");
  }
  .card-actions {
    position: absolute;
    bottom: 25px;
    right: 5px;
  }
</style>
